import {
  ListPurchaseRequestListPurchaseBillingStrategyFilterInterface,
  ListPurchaseRequestState,
  PurchaseStatus,
} from '@vendasta/billing';

export interface ListPurchaseFilter {
  merchantId?: string;
  purchaseId?: string;
  start?: Date;
  end?: Date;
  billingStrategyFilter?: ListPurchaseRequestListPurchaseBillingStrategyFilterInterface;
  state?: ListPurchaseRequestState;
  minPrice?: number;
  status?: PurchaseStatus;
  includeVoided?: boolean;
  dunningPauseStart?: Date;
}

interface ListPurchaseFilterHttp {
  merchantId?: string;
  purchaseId?: string;
  start?: string;
  end?: string;
  billingStrategyFilter?: {
    billingStrategy?: number[];
  };
  state?: number;
  minPrice?: number;
  status?: number;
  includeVoided?: boolean;
  dunningPauseStart?: string;
}

export function listPurchaseFiltersToHTTPJson(filters: ListPurchaseFilter): ListPurchaseFilterHttp {
  return {
    merchantId: filters.merchantId,
    purchaseId: filters.purchaseId,
    start: filters.start ? filters.start.toISOString() : undefined,
    end: filters.end ? filters.end.toISOString() : undefined,
    billingStrategyFilter: filters.billingStrategyFilter
      ? {
          billingStrategy: filters.billingStrategyFilter.billingStrategy
            ? filters.billingStrategyFilter.billingStrategy.map((bs) => bs.valueOf())
            : [],
        }
      : undefined,
    state: filters.state?.valueOf() || undefined,
    minPrice: filters.minPrice,
    status: filters.status,
    includeVoided: filters.includeVoided,
    dunningPauseStart: filters.dunningPauseStart ? filters.dunningPauseStart.toISOString() : undefined,
  };
}
